export default __webpack_public_path__ + "finsuite-logo-compact.858248a9.svg";